import React from 'react';
import { useNavigate } from 'react-router-dom';

import ComplaintItem from './ComplaintItem/ComplaintItem';
import ClaimStatus from '../common/ClaimStatus/ClaimStatus';

import './Complaints.css';

function Complaints() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="row">
        <ClaimStatus />
      </div>

      <div className="row" id="complaints">
        <h4 className="col-xs-12" id="complaints-header">
          HOW CAN WE HELP?
        </h4>
      </div>
      <div className="row" id="complaints-buttons">
        <div className="col-xs-2" />

        <ComplaintItem
          buttonText="Request a call from your agent"
          iconClass="request-call"
          onClick={() => navigate('/requestcontact')}
        />

        <ComplaintItem
          buttonText="Message our Customer Experience team"
          iconClass="message-complaints"
          onClick={() => navigate('/sendmessage')}
        />
      </div>
    </div>

  );
}

export default Complaints;
